import colors from '@/styles/colors'
import { Box, Grid } from '@mui/material'
import { styled } from '@mui/material/styles'

export const SearchContent = styled(Box)(({ theme }) => ({
  '& .topic-search-header': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 16px',
    borderBottom: `1px solid ${theme.palette.grey[800]}`,
    backgroundColor: 'white',
    zIndex: 10,
  },
  '& .preview-image': {
    minWidth: 130,
    height: 130,
    marginRight: 10,
    borderRadius: 8,
    objectFit: 'cover',
  },
}))

export const DetailsContent = styled(Box)({
  backgroundColor:
    'linear-gradient(90.64deg, rgba(29, 26, 27, 0.05) 0.46%, rgba(231, 237, 243, 0) 99.37%)',
  borderRadius: '5px',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  position: 'relative',
  '& .username': {
    overflowWrap: 'break-word',
  },
  '& .motto': {
    overflowWrap: 'break-word',
  },
  '& .dm-content': {
    display: 'flex',
    flexDirection: 'column-reverse',
    padding: 16,
    overflowY: 'auto',
    backgroundColor: '#FCFCFC',
    boxSizing: 'border-box',
  },
})

export const ListOverlayGradient = styled(Box)({
  background: 'linear-gradient(180deg, #211E1E0D, #211E1E00 5%)',
  display: 'flex',
  flexDirection: 'column',
  height: '100px',
  width: '100%',
})

export const GradientContainer = styled(Box)({
  background: colors.gradients.interactionPanel,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
})

export const InteractionsContent = styled(Box)(({ theme }) => ({
  background: colors.gradients.interactionPanel,

  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  position: 'relative',
  '& .dm-interaction': {
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    boxSizing: 'border-box',
    '& .view-tab': {
      display: 'flex',
      gap: '10px',
      '& button': {
        padding: '6px 15px',
        color: colors.themeBlack,
        border: `1px #CCD4DC solid`,
        backgroundColor: 'transparent',

        borderRadius: 100,
        fontSize: 13,
        '&.active': {
          color: colors.meshdomBlue,
          border: `1px ${colors.meshdomBlue} solid`,
          backgroundColor: 'white',
        },
      },
    },
  },
}))

export const NoteWrapper = styled(Grid)({
  cursor: 'pointer',
  borderRadius: 16,
  overflow: 'hidden',
  position: 'relative',
  border: `2px solid transparent`,
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  backgroundColor: 'white',
  boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04)',
  '& .action': {
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    height: 48,
    padding: '14px',
    display: 'flex',
    justifyContent: 'space-between',
    // background: 'linear-gradient(180deg, rgba(15, 23, 42, 0.6) 0%, rgba(15, 23, 42, 0) 100%)',
    // backdropFilter: 'blur(4px)',
  },
  '&:hover': {
    boxShadow: '0 12px 40px rgba(99, 102, 241, 0.12), 0 4px 16px rgba(15, 23, 42, 0.08)',
    border: `2px solid rgba(99, 102, 241, 0.2)`,
    transform: 'translateY(-4px)',
  },
  '&.active': {
    border: `3px solid #6366f1`,
    boxShadow: '0 4px 16px rgba(99, 102, 241, 0.2)',
    transform: 'translateY(-4px)',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: -3,
      left: -3,
      right: -3,
      bottom: -3,
      borderRadius: 12,
      background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
      opacity: 0.2,
      zIndex: -1,
      filter: 'blur(8px)',
    },
    '&:hover': {
      boxShadow: '0 8px 24px rgba(99, 102, 241, 0.3)',
      transform: 'translateY(-6px)',
    },
  },
  '& .more': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(15, 23, 42, 0.7)',
    backdropFilter: 'blur(8px)',
    borderRadius: '16px',
  },

  '& .overlay': {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    borderRadius: '16px',
    background: 'linear-gradient(180deg, rgba(15, 23, 42, 0.15) 0%, rgba(15, 23, 42, 0) 50%)',
    pointerEvents: 'none',
  },
})

export const AlbumPhotoItem = styled(Box)(({ photo }: { photo: string }) => ({
  backgroundImage: `url(${photo})`,
  backgroundSize: 'cover',
  height: 0,
  paddingBottom: '100%',
  margin: '3px',
  cursor: 'pointer',
}))

export const AlbumSliderWrapper = styled(Box)(({ mode }: { mode: string }) => ({
  position: mode === 'full' ? 'fixed' : 'absolute',
  top: 0,
  left: 0,
  borderRadius: mode === 'full' ? '0px' : '8px',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  background: colors.gradients.imageSlider,
  zIndex: 10,
  '& .slick-slider': {
    height: '100%',
  },
  '& .slick-list': {
    height: '100%',
  },
  '& .slick-track': {
    height: '100%',
  },
  '& .slick-slide': {
    position: 'relative',
  },
  '& .navButton': {
    backgroundColor: '#FFFFFFBB',
    borderRadius: '50%',
  },
  '& .top-section': {
    backgroundColor: '#00000022',
  },
  '& .bottom-section': {
    backgroundColor: '#00000022',
  },
}))

export const AlbumGalleryPhoto = styled(Box)(
  ({ photo, mode }: { photo: string; mode: string }) => ({
    backgroundImage: `url(${photo})`,
    backgroundSize: mode === 'full' ? 'contain' : 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    height: mode === 'full' ? '80%' : '100%',
    top: mode === 'full' ? '10%' : 0,
    width: '100%',
    position: 'absolute',
  }),
)

export const AlbumInteractionContainer = styled(Box)({
  padding: '15px 15px 15px 15px',
  height: '-webkit-fill-available',
  display: 'flex',
  flexDirection: 'column',
  '& .image': {
    maxHeight: 285,
    width: '100%',
    objectFit: 'cover',
    borderRadius: 8,
  },
  '& .view-tab': {
    display: 'flex',
    margin: '0 -15px',
    borderBottom: `1px solid ${colors.lightGrey}`,
    borderTop: `1px solid ${colors.lightGrey}`,
    '& button': {
      flex: 1,
      color: colors.darkGrey,
      borderRadius: 0,
      fontSize: 13,
      '&.active': {
        borderBottom: `1px solid ${colors.blue}`,
        color: colors.blue,
      },
    },
  },
})

export const AddAlbumPreviewItem = styled(Box)({
  margin: '8px 8px 4px 0px',
  '& img': {
    width: 104,
    height: 104,
    objectFit: 'cover',
    borderRadius: '8px',
    border: `1px solid ${colors.lightGrey}`,
  },
  '& button': {
    position: 'absolute',
    top: 4,
    right: 4,
  },
  '& .overlay': {
    position: 'absolute',
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    borderRadius: '8px',
    background: 'linear-gradient(180deg, #00000033 0.1%,  #00000000)',
  },
})

export const DMNoteWrapper = styled(Box)({
  marginLeft: 18,
  // '13px', pb: '20px'
  padding: '13px 17px 20px 23px',
  flex: 1,
  borderRadius: 12,
  backgroundColor: colors.veryLightGrey,
  border: `2px solid transparent`,
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  position: 'relative',
  '&.active': {
    border: `3px solid #6366f1`,
    backgroundColor: 'white',
    boxShadow: '0 4px 16px rgba(99, 102, 241, 0.2)',
    transform: 'translateX(4px)',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: -3,
      left: -3,
      right: -3,
      bottom: -3,
      borderRadius: 12,
      background: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
      opacity: 0.15,
      zIndex: -1,
      filter: 'blur(8px)',
    },
  },
  '& .action-button': {
    padding: 0,
  },
  '& .interaction': {
    cursor: 'pointer',
    marginRight: 20,
    fontSize: 14,
  },
})
